import {Component, OnInit} from '@angular/core';
import {DataStore, Predicates} from 'aws-amplify';
import {APIService, BonusStatus, BonusType, UpdateContractInput} from 'src/app/API.service';
import {User} from 'src/models';
import {SortDirection} from '@aws-amplify/datastore';

@Component({
    selector: 'app-force-bonus',
    templateUrl: './force-bonus.page.html',
    styleUrls: ['./force-bonus.page.scss'],
})
export class ForceBonusPage implements OnInit {
    users: User[];
    loading = false;
    bonusType: any;
    selectedBonus = 1;
    sortDirection = SortDirection.ASCENDING;

    constructor(private apiService: APIService) {
        this.bonusType = BonusType;//Object.values(BonusType);
        // 

    }

    async ngOnInit() {

        this.users = await DataStore.query(User,  Predicates.ALL, {
            sort: s => s.lastname(this.sortDirection).name(this.sortDirection),
        }); // da settare ruolo
        
    }

    async processBonus() {
        if (!(this.selectedBonus && this.from && this.to))
            return;
        let b: any;
        
        let contracts = await this.apiService.ListContracts(undefined, 500);
        
        
        switch (BonusType[this.selectedBonus]) {
            case BonusType.Bonus_Team_3:
                await this.teamBonus(contracts.items);
                break;
            case BonusType.Revenue_Bonus_4:
                b = await this.revenueBonus(contracts.items);
                break;
            case BonusType.Sponsor_Bonus_5:
                b = await this.sponsorBonus(contracts.items);
                break;
            case BonusType.Manager_Bonus_6:
                break;

        }
    }

    async revenueBonus(items) {

        let contractsByUser = this.groupBy(items, 'userID');
        for (const [key, value] of Object.entries(contractsByUser)) {

            let total = 0;
            let b = 0;
            // @ts-ignore
            for (let c: UpdateContractInput of value) {
                total = total + c.amount;
            }
            if (total <= 100000) {
                continue;
            } else if (total > 100000 && total <= 200000) {
                b = (total * 0.5) / 100;

            } else if (total > 200000 && total <= 300000) {
                b = (total * 0.75) / 100;
            } else if (total > 300000 && total <= 400000) {
                b = (total * 1) / 100;
            } else if (total > 400000 && total <= 500000) {
                b = (total * 1.25) / 100;
            } else if (total > 500000) {
                b = (total * 1.5) / 100;
            }

            
        }
    }

    async teamBonus(items) {
        let contractsByUser = this.groupBy(items, 'userID');
        for (const [key, value] of Object.entries(contractsByUser)) {

            let total = 0;
            let b = 0;
            // @ts-ignore
            for (let c: UpdateContractInput of value) {
                total = total + c.amount;
            }
            if (total <= 10000) {
                continue;
            } else if (total > 10000 && total <= 20000) {
                b = (total * 0.5) / 100;

            } else if (total > 20000 && total < 30000) {
                b = (total * 1) / 100;
            } else if (total > 30000) {
                b = (total * 1.5) / 100;
            }

            
        }
    }

    async sponsorBonus(items) {
        let contractsByUser = this.groupBy(items, 'userID');
        let users = [];
        for (const [key, value] of Object.entries(contractsByUser)) {


            let total = 0;
            let b = 0;
            // @ts-ignore
            for (let c: UpdateContractInput of value) {
                total = total + c.amount;
            }
            if (total <= 10000) {
                continue;
            } else if (total > 10000 && total <= 20000) {
                b = (total * 0.5) / 100;

            } else if (total > 20000 && total < 30000) {
                b = (total * 1) / 100;
            } else if (total > 30000) {
                b = (total * 1.5) / 100;
            }


            
        }
    }


    addBonus(userId, type, amount) {
        this.apiService.CreateBonus({
            type: type,
            userBonusId: userId,
            payDate: new Date().toDateString(),
            total: amount,
            status: BonusStatus.NonPagato,
        });
    }

    groupBy = (items, key) => items.reduce(
        (result, item) => ({
            ...result,
            [item[key]]: [
                ...(result[item[key]] || []),
                item,
            ],
        }),
        {},
    );
    from: Date = new Date();
    to: Date = new Date();
}
